export default __webpack_public_path__ + "static/media/rounded-rectangle-2-breaks.51988c07.webp";